'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
function $s_Lapp_data_PaymentDetailsKind$__EuropeanUnionSEPA__Lapp_data_PaymentDetailsKind() {
  $m_Lapp_data_PaymentDetailsKind$();
  return $t_Lapp_data_PaymentDetailsKind$__EuropeanUnionSEPA;
}
export { $s_Lapp_data_PaymentDetailsKind$__EuropeanUnionSEPA__Lapp_data_PaymentDetailsKind as $s_Lapp_data_PaymentDetailsKind$__EuropeanUnionSEPA__Lapp_data_PaymentDetailsKind };
function $s_Lapp_data_PaymentDetailsKind$__UnitedKingdom__Lapp_data_PaymentDetailsKind() {
  $m_Lapp_data_PaymentDetailsKind$();
  return $t_Lapp_data_PaymentDetailsKind$__UnitedKingdom;
}
export { $s_Lapp_data_PaymentDetailsKind$__UnitedKingdom__Lapp_data_PaymentDetailsKind as $s_Lapp_data_PaymentDetailsKind$__UnitedKingdom__Lapp_data_PaymentDetailsKind };
/** @constructor */
function $c_Lapp_data_PaymentDetailsKind$() {
  this.aF5 = null;
  this.aF6 = false;
  $n_Lapp_data_PaymentDetailsKind$ = this;
  $t_Lapp_data_PaymentDetailsKind$__EuropeanUnionSEPA = new $c_Lapp_data_PaymentDetailsKind$$anon$4("EuropeanUnionSEPA", 0);
  $t_Lapp_data_PaymentDetailsKind$__UnitedKingdom = new $c_Lapp_data_PaymentDetailsKind$$anon$4("UnitedKingdom", 1);
  $s_Lapp_data_PaymentDetailsKind$__EuropeanUnionSEPA__Lapp_data_PaymentDetailsKind();
  $s_Lapp_data_PaymentDetailsKind$__UnitedKingdom__Lapp_data_PaymentDetailsKind();
}
export { $c_Lapp_data_PaymentDetailsKind$ as $c_Lapp_data_PaymentDetailsKind$ };
$p = $c_Lapp_data_PaymentDetailsKind$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_PaymentDetailsKind$;
/** @constructor */
function $h_Lapp_data_PaymentDetailsKind$() {
}
export { $h_Lapp_data_PaymentDetailsKind$ as $h_Lapp_data_PaymentDetailsKind$ };
$h_Lapp_data_PaymentDetailsKind$.prototype = $p;
$p.bVG = (function(x$1) {
  var ev$3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_data_NonEmptyVector$().Em($s_Lapp_data_PaymentDetailsKind$__EuropeanUnionSEPA__Lapp_data_PaymentDetailsKind(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().d(new ($d_Lapp_data_PaymentDetailsKind.r().C)([$s_Lapp_data_PaymentDetailsKind$__UnitedKingdom__Lapp_data_PaymentDetailsKind()])));
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_data_NonEmptyVector$();
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((v) => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), v, v.hJ(x$1))));
  return ev$3.aa(f);
});
$p.hL = (function() {
  if ((!this.aF6)) {
    this.aF5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aF6 = true;
  }
  return this.aF5;
});
$p.dl = (function(x) {
  return x.ahJ;
});
var $d_Lapp_data_PaymentDetailsKind$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_PaymentDetailsKind$, "app.data.PaymentDetailsKind$", ({
  EL: 1,
  d: 1,
  D: 1
}));
export { $d_Lapp_data_PaymentDetailsKind$ as $d_Lapp_data_PaymentDetailsKind$ };
var $n_Lapp_data_PaymentDetailsKind$;
function $m_Lapp_data_PaymentDetailsKind$() {
  if ((!$n_Lapp_data_PaymentDetailsKind$)) {
    $n_Lapp_data_PaymentDetailsKind$ = new $c_Lapp_data_PaymentDetailsKind$();
  }
  return $n_Lapp_data_PaymentDetailsKind$;
}
export { $m_Lapp_data_PaymentDetailsKind$ as $m_Lapp_data_PaymentDetailsKind$ };
/** @constructor */
function $c_Lapp_data_PaymentDetailsKind() {
}
export { $c_Lapp_data_PaymentDetailsKind as $c_Lapp_data_PaymentDetailsKind };
$p = $c_Lapp_data_PaymentDetailsKind.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_PaymentDetailsKind;
/** @constructor */
function $h_Lapp_data_PaymentDetailsKind() {
}
export { $h_Lapp_data_PaymentDetailsKind as $h_Lapp_data_PaymentDetailsKind };
$h_Lapp_data_PaymentDetailsKind.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.hJ = (function(l) {
  var x = $s_Lapp_data_PaymentDetailsKind$__EuropeanUnionSEPA__Lapp_data_PaymentDetailsKind();
  if (((x !== null) && (x === this))) {
    var x$3 = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
    if ((x$3 === l)) {
      return "European Union (SEPA)";
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(l);
  }
  var x$5 = $s_Lapp_data_PaymentDetailsKind$__UnitedKingdom__Lapp_data_PaymentDetailsKind();
  if (((x$5 !== null) && (x$5 === this))) {
    var x$7 = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
    if ((x$7 === l)) {
      return "United Kingdom";
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(l);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(this);
});
var $d_Lapp_data_PaymentDetailsKind = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i(0, "app.data.PaymentDetailsKind", ({
  jQ: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lapp_data_PaymentDetailsKind as $d_Lapp_data_PaymentDetailsKind };
/** @constructor */
function $c_Lapp_data_PaymentDetailsKind$$anon$4(\u03b4name$2, _$ordinal$2) {
  this.ahI = null;
  this.ahJ = 0;
  this.ahI = \u03b4name$2;
  this.ahJ = _$ordinal$2;
}
export { $c_Lapp_data_PaymentDetailsKind$$anon$4 as $c_Lapp_data_PaymentDetailsKind$$anon$4 };
$p = $c_Lapp_data_PaymentDetailsKind$$anon$4.prototype = new $h_Lapp_data_PaymentDetailsKind();
$p.constructor = $c_Lapp_data_PaymentDetailsKind$$anon$4;
/** @constructor */
function $h_Lapp_data_PaymentDetailsKind$$anon$4() {
}
export { $h_Lapp_data_PaymentDetailsKind$$anon$4 as $h_Lapp_data_PaymentDetailsKind$$anon$4 };
$h_Lapp_data_PaymentDetailsKind$$anon$4.prototype = $p;
$p.s = (function() {
  return 0;
});
$p.e = (function(n) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.u = (function(n) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.t = (function() {
  return this.ahI;
});
$p.n = (function() {
  return this.ahI;
});
$p.co = (function() {
  return this.ahJ;
});
$p.U = (function(p) {
  return this;
});
var $d_Lapp_data_PaymentDetailsKind$$anon$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_PaymentDetailsKind$$anon$4, "app.data.PaymentDetailsKind$$anon$4", ({
  EM: 1,
  jQ: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1,
  r: 1,
  d: 1,
  e: 1,
  k: 1
}));
export { $d_Lapp_data_PaymentDetailsKind$$anon$4 as $d_Lapp_data_PaymentDetailsKind$$anon$4 };
var $t_Lapp_data_PaymentDetailsKind$__EuropeanUnionSEPA = null;
function $u_Lapp_data_PaymentDetailsKind$__EuropeanUnionSEPA(x) {
  $t_Lapp_data_PaymentDetailsKind$__EuropeanUnionSEPA = x;
}
export { $t_Lapp_data_PaymentDetailsKind$__EuropeanUnionSEPA as $t_Lapp_data_PaymentDetailsKind$__EuropeanUnionSEPA, $u_Lapp_data_PaymentDetailsKind$__EuropeanUnionSEPA as $u_Lapp_data_PaymentDetailsKind$__EuropeanUnionSEPA };
var $t_Lapp_data_PaymentDetailsKind$__UnitedKingdom = null;
function $u_Lapp_data_PaymentDetailsKind$__UnitedKingdom(x) {
  $t_Lapp_data_PaymentDetailsKind$__UnitedKingdom = x;
}
export { $t_Lapp_data_PaymentDetailsKind$__UnitedKingdom as $t_Lapp_data_PaymentDetailsKind$__UnitedKingdom, $u_Lapp_data_PaymentDetailsKind$__UnitedKingdom as $u_Lapp_data_PaymentDetailsKind$__UnitedKingdom };
//# sourceMappingURL=app.data.-Payment-Details-Kind.js.map
